<template>
<div class="chapter">
<div class="inner_page">
<p class="half"><a id="page_1"></a>THE BATTLES FOR</p>
<p class="half1">MONTE CASSINO</p>
<p class="half2">THEN AND NOW</p>
<p class="hsub"><em class="italic">What I saw took me back across 28 years,</em></p>
<p class="hsub1"><em class="italic">when I experienced the same loneliness</em></p>
<p class="hsub1"><em class="italic">crossing the battlefield of the Somme.</em></p>
<p class="bkaut"><span class="small">FRIDOLIN VON SENGER UND ETTERLIN</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?40e222c9